const TEMPLATE_HEADERS = [
  'YEAR',
  'STATE',
  'RATINGAREANUMERIC',
  'STATERA',
  'PRICEMETRIC',
  'HIOSPLANID',
  'CARRIERFRIENDLYNAME',
  'PLANMARKETINGNAME',
  'METAL',
  'PLANTYPE',
  'PLANCOST',
]

const EXAMPLE_ROWS = [
  '2026,AK,1,AK1,Low,73836AK0940001,Moda Health,Moda Select Alaska Standard Gold,Gold,PPO,706',
  '2026,AK,1,AK1,Median,73836AK0940001,Moda Health,Moda Select Alaska Standard Gold,Gold,PPO,706',
  '2026,AK,1,AK1,High,73836AK0930001,Moda Health,Moda Select Alaska Gold 1500,Gold,PPO,718',
]

export function buildBenchmarkSnapshotTemplateCsv(): string {
  return [TEMPLATE_HEADERS.join(','), ...EXAMPLE_ROWS].join('\n')
}

export function downloadBenchmarkSnapshotTemplate(): void {
  const csv = buildBenchmarkSnapshotTemplateCsv()
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'benchmark-plan-snapshot-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
